<template>
  <v-dialog persistent max-width="900px" v-model="status">
    <v-card>
      <v-card-title style="background-color: #01579b">
        <span v-if="!guncelle" class="headline white--text">{{$t('Add-People')}}</span>
        <span v-if="guncelle" class="headline white--text">{{$t('Edit-People')}}</span>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-tabs v-model="tabValue" color="primary" dark slider-color="primary">
          <v-tab href="#0"> {{ $t('Address-Details') }} </v-tab>
          <v-tab-item :id="'0'">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="kisibilgi">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Category')"
                          v-model="Adres.Kategori"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                         :label="$t('Member-Number')"
                          v-model="Adres.UyeNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Occupation')"
                          v-model="Adres.Meslek"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          mask="###########"
                          :label="this.$t('IDNumber')"
                          v-model="Adres.TCKimlikNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-select
                          :items="itemscinsiyet"
                          item-text="text"
                          item-value="value"
                          :label="$t('Sex')"
                          v-model="Adres.Cinsiyet"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 sm12 md4>
                        <v-text-field :label="$t('Email_label')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="this.$t('Name')"
                          v-model="Adres.Ad"
                          :rules="[
                            (v) =>
                              (!!v && v.length <= 50) ||
                              $t('Must-be-characters-maximum'),
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Surname_label')"
                          v-model="Adres.Soyad"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <tarihim
                          :etiket="$t('Date-of-Birth')"
                          :detaygizle="false"
                          v-bind:defaultvalue="'no'"
                          v-model="Adres.DogumTarihi"
                        ></tarihim>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Mother-Name')"
                          v-model="Adres.AnneAdi"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Father-Name')"
                          v-model="Adres.BabaAdi"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Place-Birth')"
                          v-model="Adres.DogumYeri"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          label="GSM"
                          v-model="Adres.GSM"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          label="Tel 1"
                          v-model="Adres.Telefon1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          label="Tel 2"
                          v-model="Adres.Telefon2"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-textarea
                          :label="$t('Address_label')"
                          v-model="Adres.Adres"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-textarea
                          :label="$t('Reservation-Notes')"
                          v-model="Adres.RezIstekleri"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-textarea
                          :label="$t('Notes')"
                          v-model="Adres.Notlar"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab href="#1">  {{ $t('Passport-Details') }}  </v-tab>
          <v-tab-item :id="'1'">
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-text-field
                          :label="$t('Passport-No')"
                          v-model="Adres.PasaportNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-select
                          hide-details
                          :items="itemsPasaportTip"
                          item-text="text"
                          item-value="value"
                          :label="$t('Passport-Type')"
                          v-model="Adres.PasaportTip"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Place-Issue')"
                      v-model="Adres.VerildigiYer"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <tarihim
                          :etiket="$t('Date-Issue')"
                          :detaygizle="false"
                          v-bind:defaultvalue="'no'"
                          v-model="Adres.VerilisTarihi"
                          v-bind:value="Adres.VerilisTarihi"
                        ></tarihim>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihim
                          :etiket="$t('Finishing-Date')"
                          :detaygizle="false"
                          v-bind:defaultvalue="'no'"
                          v-bind:value="Adres.BitisTarihi"
                          v-model="Adres.BitisTarihi"
                        ></tarihim>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="itemseskiyeni"
                      item-text="text"
                      item-value="value"
                      :label="$t('Passport-Old-New')"
                      v-model="Adres.EskiYeni"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Children-Address-Code')"
                      v-model="Adres.Cocuk1Kod"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-checkbox
                          :label="$t('Passport-Includes-Children')"
                          v-model="Adres.PspCocukVar"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-checkbox
                          :label="$t('Children-Require-Visa')"
                          v-model="Adres.PspCocukVizeIstiyor"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab href="#2">{{ this.$t('Department') }} </v-tab>

          <v-tab-item :id="'2'">
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <cariaracomp
                      v-bind:etiket="$t('Cost-Current')"
                      :Coper="true"
                      v-bind:value="Adres.dptCariKod.kod"
                      v-model="Adres.dptCariKod.kod"
                    ></cariaracomp>
                  </v-flex>
                  <v-flex xs12 sm12 md6>  
                    <geneltipara tip="Bölge" v-model="Adres.dptBolge">
                    </geneltipara>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <geneltipara tip="Yönetim" v-model="Adres.dptYonetim">
                    </geneltipara>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <geneltipara tip="Departman" v-model="Adres.dptDepartman">
                    </geneltipara>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <geneltipara
                      tip="AltDepartman"
                      v-model="Adres.dptAltDepartman"
                    >
                    </geneltipara>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <geneltipara tip="Bölüm" v-model="Adres.dptBolum">
                    </geneltipara>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab href="#3"> {{ $t('SPECIAL-OCCASIONS') }} </v-tab>

          <v-tab-item :id="'3'">
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md6>
                  <tarihim
                    :etiket="$t('Special-Day') +  ' 1'"
                    :detaygizle="false"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="Adres.OzelGun1"
                    v-model="Adres.OzelGun1"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihim
                    :etiket="$t('Special-Day') + ' 2 '"
                    :detaygizle="false"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="Adres.OzelGun2"
                    v-model="Adres.OzelGun2"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihim
                    :etiket="$t('Special-Day') + ' 3'"
                    :detaygizle="false"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="Adres.OzelGun3"
                    v-model="Adres.OzelGun3"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihim
                    :etiket="$t('Special-Day') + ' 4'"
                    :detaygizle="false"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="Adres.OzelGun4"
                    v-model="Adres.OzelGun4"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihim
                    :etiket="$t('Special-Day') + ' 5'"
                    :detaygizle="false"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="Adres.OzelGun5"
                    v-model="Adres.OzelGun5"
                  ></tarihim>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!guncelle"
          color="primary darken-1"
          text
          @click.native="addUser"
          > {{ $t('save_button') }} </v-btn
        >
        <v-btn
          v-if="guncelle"
          color="primary darken-1"
          text
          @click.native="UpdateUser"
          >{{ $t('Update') }}</v-btn
        >
        <v-btn color="grey" text @click.native="status = false">{{
          $t("cancel_button")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tarihim from "@/components/app/customcomp/tarihim.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import tool from "@/components/app/coper/tools.js";

export default {
  props: {
    value: {
      type: Object,
    }
  },
  data() {
    return {
      guncelle:false,
      Adres: {
        CreatedBy: null,
        CreatedDate: null,
        ModifiedBy: null,
        ModifiedDate: null,
        PspOfsTeslimAlan: null,
        PspOfsTeslimTarihi: null,
        PspMusTeslimEden: null,
        PspMusTeslimTarihi: null,
        dptBolge: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        dptYonetim: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        dptDepartman: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        dptAltDepartman: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        dptBolum: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        dptCariKod: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        SicilID: null,
        Id: 0,
        Kategori: null,
        Ad: null,
        Soyad: null,
        Adres: null,
        DogumTarihi: null,
        Ulke: null,
        Sehir: null,
        Meslek: null,
        Telefon1: null,
        Telefon2: null,
        GSM: null,
        Email: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
        Sigara: null,
        Notlar: null,
        USAVize: null,
        USABitis: null,
        AnneAdi: null,
        BabaAdi: null,
        TCKimlikNo: null,
        DogumYeri: null,
        Kod: 0,
        Cinsiyet: 0,
        RezIstekleri: null,
        SirketNo: null,
        UyeNo: null,
        PspCocukVar: false,
        PspCocukVizeIstiyor: false,
        Cocuk1Kod: null,
        OnlineCIn: false,
        OzelGun1: null,
        OzelGun2: null,
        OzelGun3: null,
        OzelGun4: null,
        OzelGun5: null,
        EskiYeni: null,
        Uyruk: null,
      },
      itemscinsiyet: [
        {
          text: this.$t('Male'),
          value: 1,
        },
        {
          text: this.$t('Female'),
          value: 2,
        },
      ],
      itemseskiyeni: [
        {
          text: this.$t('Old'),
          value: 0,
        },
        {
          text: this.$t('New'),
          value: 1,
        },
      ],
      tabValue: null,
      status: false,
      itemsPasaportTip: [
        {
          text: "Normal",
          value: 0,
        },
        {
          text: this.$t('Green'),
          value: 1,
        },
        {
          text: this.$t("Diplomatic"),
          value: 2,
        },
        {
          text: this.$t("Other"),
          value: 3,
        },
      ],
    };
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    UpdateUser() {
      if (this.$refs.kisibilgi.validate()) {
        this.loadingcomp = true;
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );
        this.Adres.SirketNo = credentials.CoperSirketNo;
        var params = {
          Value: this.Adres,
        };
        tool.http_post(this, "AdresUpdate", params).then(
          (response) => {
            this.loadingcomp = false;
            if (response.body.Status == true) {
              this.text1 = this.$t('Record-Updated');
              this.snackbar = true;
              this.$emit("afterSave", response.body.data);
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.loadingcomp = false;
            this.text1 = this.$t('An-error-has-occurred-Please-try-again');
            this.snackbar = true;
          }
        );
      } else {
        this.active = 0;
      }
    },
    Load(val) {
      this.guncelle = true;
      let params = {
        Id: val,
      };

      tool.http_post(this, "AdresLoad", params).then(
        (response) => {
          this.loadingvmodel = false;

          if (response.body.Status == true) {
            this.Adres = response.body.data;
            this.status = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.loadingvmodel = false;

          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );
    },
    addUser() {
      if (this.$refs.kisibilgi.validate()) {
        this.loadingcomp = true;
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );
        this.Adres.SirketNo = credentials.CoperSirketNo;
        var params = {
          Value: this.Adres,
        };
        tool.http_post(this, "AdresInsert", params).then(
          (response) => {
            this.loadingcomp = false;
            if (response.body.Status == true) {
              this.text1 = "Kayıt Eklendi";
              this.snackbar = true;
              this.$emit("afterSave", response.body.data);
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.loadingcomp = false;
            this.text1 = this.$t('An-error-has-occurred-Please-try-again');
            this.snackbar = true;
          }
        );
      } else {
        this.active = 0;
      }
    },
    open() {
      this.status = true;
    },
    close() {
      this.status = false;
    },
  },
  components: {
    tarihim,
    geneltipara,
    cariaracomp,
  },
};
</script>

<style>
</style>